export const testList = [
  {
    id: 'mockTest',
    name: 'Mock test'
  },
  {
    id: 'practiceTest',
    name: 'Practice test'
  },
  {
    id: 'subjectTest',
    name: 'Subject test'
  },
  {
    id: 'dailyTest',
    name: 'Daily basis test'
  }
]

export const testStatus = [
  {
    id: 'draft',
    name: 'Draft'
  },
  {
    id: 'published',
    name: 'Published'
  }
]

export const assignedTableHeader = [
  'Test Type',
  'Test Name',
  'Test Code',
  'Created Date',
  'Status',
  'Action'
]

export const newlyAddedTestTableHeader = [
  'Test Type',
  'Test Name',
  'Institute',
  'Branch',
  'Batch',
  'Course Name',
  'Status',
  'Action'
]
